import { render, staticRenderFns } from "./SelectionRecords.vue?vue&type=template&id=bdf345ae&"
import script from "./SelectionRecords.vue?vue&type=script&lang=js&"
export * from "./SelectionRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports